import { Component } from 'react'
import ZoneForm from '../forms/popups/ZoneForm'
import Modal from '.'

interface Zone {
  id: string
  // Define other properties of the Zone object
}

interface EditZoneModalProps {
  fields: Zone
  isOpen: boolean
  updateItem: (data: any) => void
  showToast: (options: { title: string }) => void
  fetchList: (list: string) => void
}

const MODAL_ID = 'editZone'

export class EditZoneModal extends Component<EditZoneModalProps> {
  handleSubmit = () => {
    const { fields, fetchList, showToast, updateItem } = this.props
    updateItem({
      url: `list/zones/${fields.id}`,
      onComplete: () => {
        showToast({ title: 'Updated a Zone' })
        fetchList('residents')
        fetchList('zones')
      }
    })
  }

  render() {
    const { isOpen, ...formProps } = this.props
    if (!isOpen) return null

    return (
      <ZoneForm
        formId={MODAL_ID}
        // @ts-ignore
        isEdit
        onSubmit={this.handleSubmit}
        {...formProps}
      />
    )
  }
}

export default Modal(EditZoneModal, MODAL_ID)
